import React, { useState } from "react";
import styled from "styled-components";
import { Flex, Box } from "reflexbox";

import { secondaryButtonStyles } from "../Button";
import * as colors from "../../styles/colors";
import { cloudFunctionsBaseUrl } from "../../services/firebase";

const FormContainer = styled(Flex)`
  background: rgba(12, 15, 20, 0.8);
  border: 1px solid rgba(96, 113, 123, 0.15);
  border-radius: 16px;
  padding: 36px 32px;

  @media (max-width: 768px) {
    padding: 28px 20px;
  }
`;

const EmailInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(96, 113, 123, 0.25);
  border-radius: 8px;
  color: ${colors.light};
  font-size: 15px;
  font-family: inherit;
  outline: none;
  min-width: 0;
  transition: border-color 0.2s;

  &::placeholder {
    color: ${colors.muted};
  }

  &:focus {
    border-color: rgba(42, 199, 220, 0.4);
  }
`;

const SubmitButton = styled.button`
  ${secondaryButtonStyles}
  background: transparent;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;
  margin: 0;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export function LeadMagnetForm({ slug }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);

    try {
      const response = await fetch(
        `${cloudFunctionsBaseUrl}/subscribeToNewsletterV2`,
        {
          method: "POST",
          mode: "cors",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email,
            tags: ["guide-newsletter-signup", `guide:${slug}`],
            source: "website_lead_magnet"
          })
        }
      );
      const data = await response.json();
      if (data.ok) {
        setEmail("");
        setSubmitted(true);
      }
      setMessage(data.message);
    } catch (error) {
      setMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormContainer flexDirection="column" mt={[40, 50]} width="100%">
      <Box
        fontSize={[19, 22]}
        fontWeight={500}
        color={colors.light}
        mb={[1]}
        style={{ lineHeight: "140%" }}
      >
        Stay in the loop with Neurosity, neuroscience and BCI
      </Box>
      <Box
        fontSize={[14, 15]}
        color={colors.text}
        mb={[3]}
        style={{ lineHeight: "165%" }}
      >
        Get more articles like this one, plus updates on
        neurotechnology, delivered to your inbox.
      </Box>

      {submitted ? (
        <Box
          fontSize={[15]}
          color={colors.primary}
          fontWeight={500}
          py={[1]}
        >
          You're subscribed. Welcome aboard.
        </Box>
      ) : (
        <form onSubmit={handleSubmit}>
          {message && !submitted ? (
            <Box
              fontSize={[14]}
              color={colors.primary}
              mb={[2]}
              dangerouslySetInnerHTML={{ __html: message }}
            />
          ) : null}
          <Flex
            flexDirection={["column", "row"]}
            style={{ gap: "12px" }}
          >
            <EmailInput
              type="email"
              placeholder="you@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
            <SubmitButton type="submit" disabled={loading}>
              <span>{loading ? "..." : "Subscribe"}</span>
            </SubmitButton>
          </Flex>
        </form>
      )}
    </FormContainer>
  );
}
